if (!customElements.get('planted-cart-popup')) {
  function setClassesFromAttribute(attr, el) {
    const classes = (el.getAttribute(attr) || '').split(/\s+/)
    el.classList.add(...classes)
  }

  function unsetClassesFromAttribute(attr, el) {
    const classes = (el.getAttribute(attr) || '').split(/\s+/)
    el.classList.remove(...classes)
  }

  class PlantedCartPopup extends HTMLElement {
    connectedCallback() {
      const self = this
      let initialOverScroll
      const overlayEl = this.querySelector('[data-overlay]')
      document.addEventListener('theme:show_cart', function (event) {
        openPopup()
      })

      function closePopup(event) {
        event.preventDefault()
        self.querySelectorAll('[data-show-class]').forEach(function (el) {
          unsetClassesFromAttribute('data-show-class', el)
        })
        self.setAttribute('aria-hidden', true)
        document.body.style.overflow = initialOverScroll
      }

      function openPopup() {
        self.querySelectorAll('[data-show-class]').forEach(function (el) {
          setClassesFromAttribute('data-show-class', el)
        })
        self.setAttribute('aria-hidden', false)
        initialOverScroll = document.body.style.overflow
        document.body.style.overflow = 'hidden'
      }

      overlayEl.addEventListener('click', closePopup)
      this.querySelector('[data-close]').addEventListener('click', closePopup)
    }
  }
  customElements.define('planted-cart-popup', PlantedCartPopup)
}
